import React from "react";

import { EventGiveawayFormBlock as Value } from "@reactivated";

import { EventGiveawayForm } from "../CRMForm/EventGiveawayForm";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";
import { Split } from "../SplitBlock";

import styles from "./index.module.scss";

export const EventGiveawayFormBlock = ({ value }: { value: Value }) => {
    return (
        <Split
            contentClassName={styles.contentWrapper}
            content={
                value.content ? (
                    <>
                        <RichText value={value.content} />{" "}
                        <EventGiveawayForm
                            layout="complementary"
                            terms={value.terms}
                            success_text={value.success_text}
                            /**
                             * This block existed before we set up SplitFormBlock
                             * and custom submit URLs and therefore doesn't have
                             * the custom field set up
                             */
                            custom_submit_url={null}
                        />
                    </>
                ) : null
            }
            media={value.media && <MediaChooserBlock value={value.media} />}
            contentAlignment={value.content_alignment}
            imageWidth={value.image_width}
        />
    );
};
